import * as Styled from './styled'
import { ReactComponent as SignOut } from '~assets/images/svgs/sign-out.svg'
import { ReactComponent as Telephone } from '~assets/images/svgs/telephone.svg'
import { ReactComponent as Truck } from '~assets/images/svgs/truck.svg'
import { FuelTypography } from '@frete.com/fuel-react'
import { Props } from './types'
import { useLocation, useNavigate } from 'react-router-dom'
import { usePath, useStore } from '~hooks'

function MenuOptions({ onClickLogout, isOpen, onClose }: Props) {
  const navigate = useNavigate()
  const location = useLocation()
  const store = useStore()
  const path = usePath()

  function handleClickContactNumber() {
    if (location.pathname.includes('/dados-veiculo'))
      store.update({
        saveVehicleDataModal: true,
        saveVehicleDataCallback: () => navigate('/numeros-contato', { state: { previousPath: path } }),
      })
    else navigate('/numeros-contato', { state: { previousPath: path } })
    onClose?.()
  }

  function handleClickVehicleData() {
    if (location.pathname.includes('/dados-veiculo'))
      store.update({
        saveVehicleDataModal: true,
        saveVehicleDataCallback: () => navigate('/dados-veiculo', { state: { previousPath: path } }),
      })
    else navigate('/dados-veiculo', { state: { previousPath: path } })
    onClose?.()
  }

  function handleClickLogout() {
    onClickLogout()
    onClose?.()
  }

  return (
    <>
      <Styled.Options className="menu" isOpen={isOpen}>
        <Styled.Option onClick={handleClickVehicleData}>
          <Truck />
          <FuelTypography size="caption" color="neutral-strong">
            Dados do veículo
          </FuelTypography>
        </Styled.Option>
        <Styled.Option onClick={handleClickContactNumber}>
          <Telephone />
          <FuelTypography size="caption" color="neutral-strong">
            Números de contato
          </FuelTypography>
        </Styled.Option>
        <Styled.Option onClick={handleClickLogout}>
          <SignOut />
          <FuelTypography size="caption" color="neutral-strong">
            Sair da conta
          </FuelTypography>
        </Styled.Option>
      </Styled.Options>
    </>
  )
}

export default MenuOptions
